module.exports = __webpack_public_path__ + "img/guide3_m.0e94d331.jpg";